(function () {
  "use strict";

  if ($("#form-lateral").length > 0) {
    // Variáveis (Geral)
    let dataChegada;
    let dataSaida;
    let diarias = 0;
    let hospedes = 0;
    let total = 0;

    // Variáveis (Lateral)
    const anuncioId = $("#anuncio-id").val();
    const $formLateral = $("#form-lateral");
    const $campoChegadaLat = $("#reserva-chegada");
    const $campoSaidaLat = $("#reserva-saida");
    const $campoHospedesLat = $("#reserva-hospedes");
    const $btnExibeConfirmacao = $("#btn-confirmacao");

    // Variáveis (Modal)
    const modalReserva = "modal-reserva";
    const $modalReserva = $("#" + modalReserva);
    const $mensagemValorDiferenciado = $("#msg-valor-diferenciado");
    const $chegadaView = $("#chegada-view-md");
    const $saidaView = $("#saida-view-md");
    const $hospedesView = $("#hospedes-view-md");
    const $diariasView = $("#diarias-view-md");
    const $diariasViewResumo = $("#diarias-view-resumo");
    const $diariasViewResumoTaxas = $(".diarias-view-resumo-taxas");
    const $diariasViewResumoSubtotal = $("#diarias-view-resumo-subtotal");
    const $diariasViewResumoTotal = $("#diarias-view-resumo-total");
    const $chegadaInput = $("#chegada-md");
    const $saidaInput = $("#saida-md");
    const $hospedesInput = $("#hospedes-md");
    const $diariasInput = $("#diarias-md");
    const $totalInput = $("#reserva-total");
    const $taxasInput = $("#reserva-taxas");
    const $totalSemTaxasInput = $("#reserva-total-sem-taxa");
    const $anuncioLatPreco = $(".anuncio-lat-preco");
    const $valorPreview = $(".valorPreview");
    const $divValorPreview = $(".div-valor-preview");

    // Processa formulário da lateral
    $formLateral.on("submit", function (ev) {
      ev.preventDefault();
      // Valida o formulário
      if ($formLateral.parsley().validate()) {
        exibeModalReserva();
      }
    });

    // Mínimo de noites
    const minNoites = $("#min-noites").val()
      ? parseInt($("#min-noites").val())
      : 9999;
    // Ao mudar as datas mostra valor da solicitação
    $(".datepicker_range_reserva").on("apply.daterangepicker", function (
      ev,
      picker
    ) {
      const chegada = picker.startDate.format("DD/MM/YYYY");
      const saida = picker.endDate.format("DD/MM/YYYY");
      const datasRange = getDateRange(dataToObj(chegada), dataToObj(saida));
      const totalNoites = datasRange.length - 1;
      // Verifica se a quantidade de dias é menor do que o mínimo permitido
      if (totalNoites >= minNoites) {
        exibePreVisualizacaoDeValor();
      } else {
        $anuncioLatPreco.show();
        $divValorPreview.hide();
        clearDatas();
        showAlert(
          "Atenção",
          "Por favor, escolha no mínimo <b>" + (minNoites + 1) + " dias</b>.",
          "warning"
        );
      }
    });

    // Calcula pré-visualizacao de valor
    function exibePreVisualizacaoDeValor() {
      dataChegada = $campoChegadaLat.val();
      dataSaida = $campoSaidaLat.val();
      hospedes = $campoHospedesLat.val();
      diarias =
        getDateRange(dataToObj(dataChegada), dataToObj(dataSaida)).length - 1;

      var retornoValorReserva = getValorReserva();

      if (retornoValorReserva == "exibe-reserva") {
        $anuncioLatPreco.hide();
        $divValorPreview.show();
      } else if (retornoValorReserva == "erro") {
        showAlert("Erro", "Não foi possível realizar esta operação.", "error");
      } else {
        setTimeout(() => {
          $("#reserva-chegada").val("").trigger("change");
          $("#reserva-saida").val("").trigger("change");
        }, 100);
        showAlert(
          "Atenção",
          "Para esse período deve ser selecionado <b>" +
            retornoValorReserva +
            "</b>.",
          "warning"
        );
      }
    }

    // Exibe o modal de confirmação
    function exibeModalReserva() {
      dataChegada = $campoChegadaLat.val();
      dataSaida = $campoSaidaLat.val();
      hospedes = $campoHospedesLat.val();
      diarias =
        getDateRange(dataToObj(dataChegada), dataToObj(dataSaida)).length - 1;

      var retornoValorReserva = getValorReserva();

      if (retornoValorReserva == "exibe-reserva") {
        $chegadaView.val("Chegada: " + dataChegada);
        $saidaView.val("Saída: " + dataSaida);
        $hospedesView.val(hospedes + " hóspede(s)");
        $diariasView.val(diarias + " noite(s)");

        $diariasViewResumo.html(diarias);
        $diariasViewResumoTaxas.html(diarias);
        $chegadaInput.val(dataChegada);
        $saidaInput.val(dataSaida);
        $diariasInput.val(diarias);
        $hospedesInput.val(hospedes);
        openModal(modalReserva);
      } else if (retornoValorReserva == "erro") {
        showAlert("Erro", "Não foi possível realizar esta operação.", "error");
      } else {
        $anuncioLatPreco.show();
        $divValorPreview.hide();
        showAlert(
          "Atenção",
          "Para esse período deve ser selecionado <b>" +
            retornoValorReserva +
            "</b>.",
          "warning"
        );
      }
    }

    // Obtém o valor total da reserva
    function getValorReserva() {
      const urlCalc =
        url_base +
        "acoes/app/anuncios/calcular_diarias.php?anuncio=" +
        anuncioId +
        "&chegada=" +
        dataChegada +
        "&saida=" +
        dataSaida +
        "&hospedes=" +
        hospedes +
        "&diarias=" +
        diarias;
      var retornoReservas;
      $.ajax({
        url: urlCalc,
        dataType: "json",
        async: false,
        success: function (result) {
          console.log(result);
          $(".multiplica-valor").each(function (index) {
            $(this).html(formataMoeda($(this).data("valor-taxa") * diarias));
          });
          $diariasViewResumoSubtotal.html(
            formataMoeda(result.valor_total_sem_taxas)
          );
          $diariasViewResumoTotal.html(
            formataMoeda(result.valor_total_com_taxas)
          );
          $totalInput.val(result.valor_total_com_taxas);
          $valorPreview.html(formataMoeda(result.valor_total_com_taxas));
          $taxasInput.val(result.valor_taxas);
          $totalSemTaxasInput.val(result.valor_total_sem_taxas);
          if (result.valor_diferenciado == true) {
            if (result.datas_diferenciado_aprovado == true) {
              retornoReservas = "exibe-reserva";
            } else {
              retornoReservas = result.datas_valor_diferenciado;
            }
            $mensagemValorDiferenciado.show();
          } else {
            retornoReservas = "exibe-reserva";
            $mensagemValorDiferenciado.hide();
          }
        },
        error: function (xhr, type, exception) {
          retornoReservas = "erro";
        },
      });
      return retornoReservas;
    }

    // Envia a solicitação
    let enviandoFormulario = false;
    $("#form-reserva").on("submit", function (e) {
      e.preventDefault();
      var obj = this;
      var form = $(obj);
      var dados = new FormData(obj);
      function volta_submit() {
        enviandoFormulario = false;
        closeModal(modalReserva);
        hideLoading();
      }
      if (!enviandoFormulario) {
        $.ajax({
          url: form.attr("action"),
          type: form.attr("method"),
          data: dados,
          processData: false,
          cache: false,
          contentType: false,
          beforeSend: function () {
            showLoading();
            enviandoFormulario = true;
          },
          success: function (data) {
            console.log(data);
            volta_submit();
            if (data == "ok") {
              $("#form-reserva .campo").val("");
              showAlert(
                "Sucesso",
                "Obrigado! Sua solicitação foi enviada com sucesso. Em breve um de nossos especialistas entrarão em contato, a página irá ser recarregada.",
                "success"
              );
              setTimeout(function () {
                location.reload();
              }, 6000);
            } else if (data == "erro_pessoas") {
              showAlert(
                "Erro",
                "O número de hóspedes excede o permitido para o imóvel.",
                "error"
              );
            } else {
              showAlert(
                "Erro",
                "Não foi possível realizar esta operação.",
                "error"
              );
            }
          },
          error: function (xhr, type, exception) {
            console.log("ajax error response type " + type);
            volta_submit();
            showAlert(
              "Erro",
              "Não foi possível realizar esta operação.",
              "error"
            );
          },
        });
      }
    });
  }
})();
